export const setupCheckoutSymbols = (app, store, checkoutOptions) => {
  app.config.globalProperties.$cyrLetters =
    'абвгдеёжзийклмнопрстуфхцчшщъыьэюя' +
    'абвгдеёжзийклмнопрстуфхцчшщъыьэюя'.toUpperCase()

  app.config.globalProperties.$latinRegex =
    /[^0-9a-zA-Z\u00C0-\u017F\s.,!?;/:"'()-]/g

  const countryCode = store.state.IS_COUNTRY_GLOBAL
    ? store.state.CUR_LOCATION.CODE
    : store.state.country.code
  const countriesOT = store.state.CUR_LOCATION.CODE === 'OT'
  const isLatinOnly =
    countriesOT || checkoutOptions.latinOnly.includes(countryCode)
  const isNoCyrSymbols = checkoutOptions.noCyrCountries.includes(countryCode)

  app.config.globalProperties.$latinOnly = isLatinOnly
  app.config.globalProperties.$noCyrSymbols = isNoCyrSymbols
}
